<template>
  <CSidebar class="pretest-sidebar" position="fixed" :visible="true">
    <div class="brand">
      <CSidebarBrand>
        <img src="@/assets/images/logo-black.svg" />
      </CSidebarBrand>
    </div>
    <div class="button-wrapper">
      <button
        v-for="item in isDisplayList"
        :key="item"
        :style="
          $route.path === `/result/${listId}/${item.id}`
            ? 'background: #D1E5EF'
            : 'background: #f3f8fb'
        "
        @click="$router.push(`/result/${listId}/${item.id}`)"
        class="border-0 btn mt-2 mx-auto text-dark edit-options-btn position-relative d-flex justify-content-between align-items-center"
      >
        <span> {{ item.title }}</span>
        <div>
          {{searchFinishData(item.id)[0]}}/{{searchFinishData(item.id)[1] }}
        </div>
      </button>
    </div>
  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { ItemTypes, Part_Is_Display_Yes } from '../../defines'
export default {
  name: 'PreTestSidebar',
  props: {
    questionnaireOptions: {
      type: Array,
      default: () => [],
    },
    listId: {
      type: String,
      default: '',
    },
    finishCount:{
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    const searchFinishData = (id)=>{
      if(id && props.finishCount.length){
        const item = props.finishCount.find(e=>e.part_id === id)
        if(item.done_count+item.undone_count+item.unknown_count === 0){
          const item = props.questionnaireOptions.find(e=>e.id === id)
          return [0, item.items?.length || 0]
        }else{
          return [item.done_count, item.done_count+item.undone_count+item.unknown_count]
        }
      }else{
        const item = props.questionnaireOptions.find(e=>e.id === id)
        let count = 0
        item.items.forEach(e=>{
          if(e.type !== ItemTypes.Introduction){
            count += 1
          }
        })
        return [0, count]
      }
    }
    const isDisplayList = computed(() => {
      return props.questionnaireOptions.filter(
        (e) => e.is_display === Part_Is_Display_Yes,
      )
    })
    return {
      isDisplayList,
      searchFinishData
    }
  },
}
</script>

<style lang="scss" scoped>
:global(.pretest-sidebar) {
  --cui-sidebar-brand-bg: none;
  --cui-sidebar-color: #4d4d4d;
  border-radius: 0 20px 20px 0;
  border: 1px solid #eff0f6;
  background: #ffffff;
  filter: drop-shadow(0px 5px 20px rgba(0, 0, 0, 0.05));
}
.brand {
  padding: 24px 0;
  img {
    width: 120px;
  }
}
.content-wrapper {
  padding: 0 25px;
}
.selection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 8px 10px 16px;
  gap: 10px;
  margin-bottom: 35px;
  background: #f3f8fb;
  border-radius: 10px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.154px;
  color: #187baf;
}
.link {
  display: block;
  margin-bottom: 40px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.154px;
  color: #4d4d4d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
}
.edit-options-btn {
  font-size: 14px;
  width: 192px;
  height: 48px;
  display: flex;
  justify-content: left;
  align-items: center;
  color: #177baf;
  border-radius: 4px;
  span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
.button-wrapper{
  height: calc(100vh - 40px);
  padding-bottom: 20px;
  overflow-y: scroll;
}
</style>
